import ssrs from './ssrs'

export default [ssrs]
